module.exports = __webpack_public_path__ + "img/product-01.78462502.jpg";